import axios from '~/axios';

axios.interceptors.request.use((config) => {
    const token = sessionStorage.getItem("access_token");
    config.headers.Authorization = `Bearer ${ token }`;
    return config;
});

import {
    ADD_ARTICLE,
    LOG_IN,
    LOG_OUT,
    VERIFY,
    UPDATE_DASHBOARD_TABLE,
    UPDATE_DASHBOARD_SEARCH
} from "../constants/action-types";

export function logIn(user) {
    return { type: "LOG_IN", payload: user }
}

export function logOut() {
    return { type: "LOG_OUT" }
}

export function updateDashboardTable(page, filters, sorter) {
    console.log({ page, filters, sorter })
    console.log("going to launch reducer with dashboard action type")
    return { type: "UPDATE_DASHBOARD_TABLE", payload: { page, filters, sorter } }
}

export function updateDashboardSearch(query) {
    console.log("going to launch reducer with dashboard action type")
    return { type: "UPDATE_DASHBOARD_SEARCH", payload: query }
}

export function verify() {
    return (dispatch) => {
        axios.get("api/user").then(response => {
            dispatch(logIn(response.data));
        }).catch(error => {
            // console.error(err);
        });
    }
}

const initialState = {
    isAuthenticated: false,
    user: [],
    dashboardPage: 0,
    dashboardSorter: {},
    dashboardSearch: ''
};

const rootReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOG_IN:
            return {
                ...state,
                user: action.payload,
                isAuthenticated: true
            }
        case LOG_OUT:
            return initialState;
        case UPDATE_DASHBOARD_TABLE:
            console.log("update dashboard page")
            return {
                ...state,
                dashboardPage: action.payload.page,
                dashboardSorter: action.payload.sorter
            }
        case UPDATE_DASHBOARD_SEARCH:
            console.log("update dashboard search")
            return {
                ...state,
                dashboardSearch: action.payload
            }
        default:
            return state;
    }
};

export default rootReducer;
